import { ReactNode } from 'react';

import useViewport from '@/hooks/useViewport';

export type TitleProps = {
  children?: ReactNode;
};

const MobileTitle = (props: TitleProps) => {
  const { children } = props;

  return (
    <div className={`pt-[112px] pb-[40px] text-gray-600`}>
      <span className={`font-roboto text-h1 font-bold`}>{children}</span>
    </div>
  );
};

const DesktopTitle = (props: TitleProps) => {
  const { children } = props;

  return (
    <div className={`pt-[112px] pb-[72px] text-gray-600`}>
      <span className={`font-mont text-[40px] font-bold leading-[50px]`}>
        {children}
      </span>
    </div>
  );
};

const Title = (props: TitleProps) => {
  const {} = props;
  const viewport = useViewport();

  if (viewport == `mobile`) {
    return <MobileTitle {...props} />;
  }
  if (viewport == `tablet` || viewport == `desktop`) {
    return <DesktopTitle {...props} />;
  }

  return null;
};

export default Title;
